import React from "react";
import style from "./style.module.css";
import classNames from "classnames/bind";

export interface IAnchorMenuProps {
    anchorList: string[];
    selectedAnchor: string;
    handleMenuClick: (anchor: string) => void;

}

export class AnchorMenu extends React.Component<IAnchorMenuProps> {
    constructor(props: IAnchorMenuProps) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);
    }

    private clickHandler(anchor: string): () => void {
        return () => {
            this.props.handleMenuClick(anchor);
        }

    }

    render() {
        const boundClasses = classNames.bind(style);

        return (
            <aside className={style.anchorMenu}>
                {
                    this.props.anchorList.map((anchor: string, index: number) => {
                        const className = boundClasses(
                            { [style.anchor]: true },
                            { [style.anchorSelected]: this.props.selectedAnchor === anchor }
                        )
                        const prefix = index < 10 ? `0${index}` : index;

                        return (
                            <a
                                href={`#${anchor}`}
                                key={anchor}
                                className={className}
                                onClick={this.clickHandler(anchor)}
                            >
                                <div className={style.bubble}></div>
                                <span className={style.label}>{`${prefix} ${anchor}`}</span>
                            </a>
                        );
                    })
                }
            </aside>
        );
    }
}